import React from 'react';
import Image from '../../../components/AppImage';

const LoginHeader = () => {
  return (
    <div className="text-center mb-8">
      {/* Logo */}
      <div className="flex items-center justify-center mb-6">
        <div className="flex items-center space-x-3">
          <div className="w-12 h-12 rounded-xl flex items-center justify-center">
            <Image src="/assets/images/tarastb.png" />
          </div>
          <div className="text-left">
            <h1 className="text-2xl font-bold text-foreground">TARA STB</h1>
            <p className="text-sm text-muted-foreground -mt-1">Operator Panel</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginHeader;